import React, { Component } from "react";

export default class MenuTile extends Component {
  render() {
    var container = {
        width      : this.props.width || "100%",
        height     : this.props.height || "100%",
        background : "red"
    }
    return (
      <div style={container}>
        ciao
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/component_SGMenuTiles.js